import { render, staticRenderFns } from "./TextAnnouncementList.vue?vue&type=template&id=12f43ead&scoped=true"
import script from "./TextAnnouncementList.vue?vue&type=script&lang=js"
export * from "./TextAnnouncementList.vue?vue&type=script&lang=js"
import style0 from "./TextAnnouncementList.vue?vue&type=style&index=0&id=12f43ead&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f43ead",
  null
  
)

export default component.exports